import { Badge, HeroSelectField, PageHeader } from '../Ui';

export interface ControlTowerBranch {
  id: string;
  name: string;
}

export type SseStatus = 'idle' | 'connecting' | 'connected' | 'error';

const sseLabels: Record<SseStatus, string> = {
  idle: 'Sin conexión',
  connecting: 'Conectando…',
  connected: 'En vivo',
  error: 'Reconectando…',
};

const sseTone: Record<SseStatus, 'slate' | 'amber' | 'green' | 'red'> = {
  idle: 'slate',
  connecting: 'amber',
  connected: 'green',
  error: 'red',
};

interface ControlTowerHeaderProps {
  sseStatus: SseStatus;
  branches: ControlTowerBranch[];
  branchId: string;
  onBranchChange(branchId: string): void;
  canChooseBranch: boolean;
}

export function ControlTowerHeader({
  sseStatus,
  branches,
  branchId,
  onBranchChange,
  canChooseBranch,
}: ControlTowerHeaderProps) {
  return (
    <PageHeader
      title="Torre de Control"
      description="Supervisión de pedidos en tiempo real por sucursal."
      action={
        <div className="flex flex-wrap items-center gap-3">
          <Badge tone={sseTone[sseStatus]}>{sseLabels[sseStatus]}</Badge>
          <div className="flex items-center gap-2">
            <HeroSelectField
              label="Sucursal"
              value={branchId || null}
              isDisabled={!canChooseBranch}
              onChange={(value) => onBranchChange(String(value ?? ''))}
              className="min-w-56"
              aria-label="Sucursal"
              options={branches.map((branch) => ({ id: branch.id, label: branch.name }))}
            />
          </div>
        </div>
      }
    />
  );
}
